import loginApi from '@/api/vipApi'
import router from '@/router'

const getDefaultState = () => {
  return {
    id: '',
    memberLevel: 0,
    userPhone: '',
    nickname: '',
    userType: 0
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_USERINFO: (state, userInfo) => {
    state.id = userInfo.id
    state.memberLevel = userInfo.memberLevel
    state.userPhone = userInfo.userPhone
    state.nickname = userInfo.nickname
    state.userType = userInfo.userType
  }
}

const actions = {
  // user login
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      loginApi.memberGet().then(response => {
        if (response.code === 200) {
          const { data } = response
          commit('SET_USERINFO', data)
          resolve(response)
        } else {
          reject(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js